import { TopicDetailView } from "@features/dashboard";
import { useReport } from "@features/report/hooks/useReport";
import { useLocalSearchParams } from "expo-router";

const DetailedListTopicsContainer = () => {
	const { type } = useLocalSearchParams<{
		type: string;
	}>();
	const { reportDetails } = useReport();

	if (!reportDetails) {
		return null;
	}

	const { tagDetails } = reportDetails;

	return <TopicDetailView title={type!} tags={tagDetails} />;
};

export default DetailedListTopicsContainer;
